import React from "react";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Header from "./Header";
import Footer from "./Footer";
import HeadingNavbar from "./HeadingNavbar";
import Blog from "./Blog";

export default function BlogPage() {
  return (
    <div>
      <HeadingNavbar />
      <Header />
      <div className="my-5">
        <Blog />
      </div>
      <Footer />
    </div>
  );
}
